import React from 'react';
import { Game } from '../classes/Game';
import { Stats } from '../classes/Stats';
import { Player } from '../classes/Player';

interface EndExitDialogInterface {
    gameId: string;
    playerId: number;
    isHost: boolean;
    statsId: number;
    closeDialog: any;
};

function EndExitGameDialog({gameId, playerId, isHost, statsId, closeDialog}: EndExitDialogInterface) {
    const handleEndExitGame = async () => {
        if (isHost) {
            await Game.updateGameStatus(gameId, 2);
            Stats.updateEndEarlyStats(statsId);
        } else {
            await Player.updatePlayerStatus(playerId, 2);
            Stats.updateDropoffCount(statsId);
        }
    }

    const handleClose = () => {
        closeDialog()
    }

    return (
        <div className="endExitGameDialogWrapper">
            <div className="endExitGameDialogBottom">
                <h1 className="endExitGameDialogTitle">{isHost ? "End the game?" : "Leaving the game?"}</h1>
                <button className="endExitGameDialogYesButton" onClick={handleEndExitGame}>YES</button>
                <button className="endExitGameDialogNoButton" onClick={handleClose}>NO</button>
            </div>
        </div>
    );
};

export default EndExitGameDialog;